import React from 'react';
import { Platform } from 'react-native';

/**
 * Off-screen mount point for InnoCalls' WebRTC dialer widget (usePhoneDialer
 * mounts InnocallsRTC into '#innocalls-dialer-root'). Never visible — no
 * InnoCalls UI is ever shown to the user, matching the product requirement.
 * Web only; must exist in the DOM before usePhoneDialer's init effect runs,
 * so it's rendered once at the app root (see App.tsx), not per-screen.
 */
export const PhoneDialerRoot: React.FC = () => {
  if (Platform.OS !== 'web') return null;

  return (
    <div
      id="innocalls-dialer-root"
      style={{
        position: 'fixed',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        opacity: 0,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    />
  );
};
